// Тонкая обёртка над Яндекс.Метрикой.
// Работает только если счётчик подключён (см. public/index.html — переменная window.__ymId).
// Если Метрики нет — вызовы молча превращаются в no-op, приложение не падает.

export const trackGoal = (goal, params) => {
  try {
    if (typeof window === 'undefined') return;
    if (!window.ym || !window.__ymId) return;
    window.ym(window.__ymId, 'reachGoal', goal, params);
  } catch {
    // Метрика упала — это не должно ломать сайт
  }
};
